window.addEventListener('load', function () {
    //Dans la carte SVG, sur tous les elements cliquables, la classe js-redirection-mission a été ajouté
    //Pour chacun de ces éléments, un data-name a été ajouté avec le nom de la ville où est la mission locale
    //Au clic sur un de ces élements, on ouvre la page de la mission locale correspondante
    let redirectionElements = document.querySelectorAll('.js-redirection-mission');
    if (redirectionElements != null && redirectionElements.length !== 0) {
        //Récupération des correspondances : Ville => Site
        //Passé en data attribute dans le SVG
        //Source : https://symfony.com/doc/current/frontend/encore/server-data.html
        let donneesVillesElement = document.querySelector('.js-donnes-villes');

        if (donneesVillesElement != null) {
            if (donneesVillesElement.getAttribute('data-villes') != null) {
                let donneesVilles = JSON.parse(donneesVillesElement.getAttribute('data-villes'));
                donneesVillesElement.remove();
                if (donneesVilles != null) {

                    //Pour chaque élément, capter l'événement au clic (pour ouvrir un nouvel onglet vers la bonne page)
                    redirectionElements.forEach(function (redirectionElement) {
                        redirectionElement.addEventListener('click', function (e) {
                            e.preventDefault();
                            let ville = redirectionElement.getAttribute('data-name');
                            //Récupérer la ville de l'API correspond à la ville cliquée (pour récupérer l'URL)
                            let villeAPI = donneesVilles.find(donneesVille => {
                                return donneesVille.city_slug === ville;
                            });
                            if (ville != null && villeAPI != null && villeAPI.url != null) {
                                //Ouvre l'URL dans un nouvel onglet
                                window.open(villeAPI.url, '_blank', 'noopener, noreferrer');
                            }
                        })
                    });
                }
            }
        }
    }
});